import React, { Component, useEffect, useState } from 'react';
import Subheader from './header/subheader'
import Search from './header/search'
import finngen from '../img/finngen_logo.svg'
import * as d3 from "d3";

function Header (props) {

    const network = props.network
    const heatmap = props.heatmap
    const updateHeatmap = props.updateHeatmap
    const search = props.search
    const setSearch = props.setSearch
    const endpoints = props.endpoints
    const setEndpoints = props.setEndpoints
    const view = props.view
    const setView = props.setView
    const format = props.format
    
    function getStatus(item) {
        if (item === 'network') {
          if (network === undefined) return 'inactive_btn'
          else {
            if (view === 'network') return 'active_btn'
            else return 'undefined'
          }
        }
        else if (item === 'heatmap') {
          if (heatmap.length === 0) return 'inactive_btn'
          else {
            if (view === 'heatmap') return 'active_btn'
            else return 'undefined'
          }
        }
      }



    return (
      <div id="header" onMouseLeave={()=>d3.select('#h_sub').style('top', '-300px').style('opacity', 0)}>
        
        <div id="h_main">
          <div id="h_container">
            <div id="h_finngen" 
              onMouseOver={()=>document.getElementById('h_logo').style.marginLeft = 0}
              onMouseOut={()=>document.getElementById('h_logo').style.marginLeft = -386 + "px"}>
              <img src={finngen} alt="Finngen logo" width="20" />
            </div>
            <div id="h_logo">
              <h1 id="h_logo_name">The Endpoint Browser</h1>
              <h1 id="h_logo_release">FinnGen Release 11</h1>
            </div>  
            <div id="h_search">
              <Search 
                search={search} 
                setSearch={setSearch} 
                setEndpoints={setEndpoints}
                setView={setView}/>
            </div>
          </div>
          <div id="h_buttons">
            <button
              id="lists_btn"
              className={view === 'lists' ? 'active_btn' + ' segmented_btn' + ' margin-right': 'segmented_btn' + ' margin-right'}
              onClick={()=>setView('lists')}
              >
                Lists
            </button>
            <button
              id="network_btn"
              className={getStatus('network') + ' segmented_btn' + ' margin-right'}
              onClick={()=>setView('network')}
              >
                Network
            </button>
            <button 
                id="heatmap_btn"
                className={getStatus('heatmap') + ' segmented_btn'} 
                onClick={()=>setView('heatmap')}
                onMouseEnter={()=>d3.select('#h_sub').style('top', '42px').style('opacity', 1)}
                >
                  Heatmap
            </button>
          </div>
          <div id = "issue_container">
            <button id="issue_btn"><a target="_blank" href="https://airtable.com/shrTzTwby7JhFEqi6">Report an issue</a></button>
          </div>
        </div>
        <Subheader 
          format={format}
          heatmap={heatmap}
          updateHeatmap={updateHeatmap}
          />
      </div>
    )
}

export default Header;